// deno-fmt-ignore-file
import { Memory } from '../../system/memory/index.mjs';
import { Guard } from '../../guard/index.mjs';
import { IsSchema } from './schema.mjs';
/** Removes Readaonly from the given type. */
export function ReadonlyRemove(type) {
    return Memory.Discard(type, ['readOnly']);
}
/** Adds Readonly to the given type. */
export function ReadonlyAdd(type) {
    return Memory.Update(type, {}, { 'readOnly': true });
}
// ------------------------------------------------------------------
// Factory
// ------------------------------------------------------------------
/** Applies an Readonly modifier to the given type. */
export function Readonly(type) {
    return ReadonlyAdd(type);
}
// ------------------------------------------------------------------
// Guard
// ------------------------------------------------------------------
/** Returns true if the given value is a TReadonly */
export function IsReadonly(value) {
    return IsSchema(value) && Guard.HasPropertyKey(value, 'readOnly');
}
